const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  permissionList: state => state.user.permissionList,
  userComponents: state => state.user.userComponents,
  addRouters: state => state.user.addRouters,
  travelMapInfo: state => state.travelMap.travelMapInfo
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js